import { Typography } from '@mui/material';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../index';

export const Archive = ({ mailpieces, actionStarted, onActionFinish, isForce }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();

  const confirmAction = async () => {
    await updatePieces({
      pieces: mailpieces.map((piece) => ({ id: piece.id })),
      action: PieceAction.Archive,
      isForce,
    }).unwrap();

    onActionFinish();
  };

  const content =
    mailpieces.length === 1 ? (
      'Are you sure you would like to archive this item?'
    ) : (
      <Typography variant="body1" color="text.secondary">
        Are you sure you would like to archive <strong>{mailpieces.length}</strong> items?
      </Typography>
    );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="xs"
      title={mailpieces.length === 1 ? 'Archive item' : 'Archive selected items'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Archive"
      cancelButtonTitle="Cancel"
    />
  );
};
